import {httpLogout, httpUserMe} from '@/features/auth/services/auth.http.ts'
import i18next from 'i18next'
import {useAuthStore} from '@/features/auth/store/store.ts'
import {parseAxiosPromise} from '@/axiosInstance.ts'
import {captureException} from '@sentry/react'
import {AuthUser} from '@/features/auth/types.ts'
import {toast} from '@/utilities/toast/toast'

export const userMe = async () => {
    try {
        const user = await parseAxiosPromise({
            axiosPromise: httpUserMe(),
            onZodError: captureException,
            responseShape: AuthUser
        })
        useAuthStore.setState(() => ({user}))
    } catch (e) {
        toast.error(i18next.t('errors:default'))
    }
}

export const logout = async () => {
    try {
        await httpLogout()
        useAuthStore.getState().reset()
    } catch (e) {
        toast.error(i18next.t('errors:default'))
    }
}
